<template lang="pug">
map-view.flood-monitoring
	tfm-map(
			ref="map"			
			:center="Detroit"
			:zoom=9
			:aggressive-position-saving="true"
			:zoomControl="false"
			@map:mounted="onMapMounted"
		)
		template
			LRectangle(
				v-for="fd in floodData" v-bind:key="fd.floodDssId"
				:bounds="fd.floodPolygon"
				:stroke="true"
				:color="fd.mapColor"
				:weight="5"
				:fill="true"
				:fillColor="fd.mapColor"
				:fillOpacity=".5"
			)
			location-marker(
				v-if="showGridCells"
				v-for="fd in floodData" v-bind:key="fd.weatherGridCellId"
				:lat-lng="{lat: fd.centerLatitude, lng: fd.centerLongitude}"
				:icon="getIcon(fd.weatherGridCellId)"
			)
		template
			location-marker(
				v-for="wsd in weatherStationData" v-bind:key="wsd.siteId"				
				:latLng="[wsd.latitude, wsd.longitude]"
				:icon="wxMarker"
			)
				LPopup(
					:lat-lng="{lat: wsd.latitude, lng: wsd.longitude}"
					:content="wsd.toolTip"
				)
					

			location-marker(
				v-for="sgd in streamGageData" v-bind:key="sgd.siteId"
				:lat-lng="{lat: sgd.latitude, lng: sgd.longitude}"
				:icon="sgMarker"
				)
				LPopup(
					:lat-lng="{lat: sgd.latitude, lng: sgd.longitude}"
					:content="sgd.toolTip"
				)
</template>

<script>
import Vue from "vue";
import * as L from "leaflet";
import LocationMarker from "@/components/map-markers/Default";
import { Component } from "vue-property-decorator";
import MapView from "../MapView.vue";
import TfmMap from "../../components/BigMap.vue";
import FloodDssSidebar from "../FloodDSS/FloodDssSidebar.vue";
import Service from "@/api/service";
import WindowManager from "../../components/WindowManager.vue";
import {
	LCircle,
	LMarker,
	LPopup,
	LRectangle,
	LTooltip,
	LIcon
} from "vue2-leaflet";

@Component({
	components: {
		FloodDssSidebar,
		LCircle,
		LIcon,
		LMarker,
		LPopup,
		LRectangle,
		LTooltip,
		MapView,
		TfmMap,
		WindowManager,
		LocationMarker
	},
	data() {
		return {
			wxMarker: L.icon({
				iconUrl: require(`@/map-icons/marker-icon-red.png`),
				iconSize: [25, 41],
				iconAnchor: [12, 41]
			}),
			sgMarker: L.icon({
				iconUrl: require(`@/map-icons/marker-icon-blue.png`),
				iconSize: [25, 41],
				iconAnchor: [12, 41]
			})
		};
	}
})
class FloodDss extends Vue {
	isLoaded = false;
	floodData = {};
	weatherStationData = {};
	streamGageData = {};
	topLeftLat = 42.7495263;
	topLeftLong = -83.55366263;
	bottomRightLat = 42.053116;
	bottomRightLong = -82.610097;
	Detroit = { lat: 42.3314, lng: -83.0458 };
	mapObject = null;
	legendObj = null;
	showGridCells = false;

	async mounted() {
		await this.loadData();
	}

	/**
	 * Callback for zoom changes on map.
	 * Sets showGridCells property to false if map is too far zoomed out.
	 */
	showGridCellIds() {
		if (this.$refs.map && this.$refs.map.mapObject.getZoom() > 7) {
			this.showGridCells = true;
			return;
		}
		this.showGridCells = false;
	}

	/**
	 * Returns a Leaflet divIcon for displaying WeatherGridCellId.
	 */
	getIcon(text) {
		return L.divIcon({
			html: text,
			iconSize: [24, 24],
			iconAnchor: [12, 12],
			className: "grid-cell-id"
		});
	}

	async loadData() {
		try {
			let floodResult = await Service.getFloodData();
			if (floodResult.ok === false) {
				throw floodResult.errorMessage;
			}
			this.floodData = floodResult.data;

			let weatherStationResult = await Service.getWeatherStationsByArea(
				this.topLeftLat,
				this.topLeftLong,
				this.bottomRightLat,
				this.bottomRightLong
			);
			if (weatherStationResult.ok === false) {
				throw weatherStationResult.errorMessage;
			}
			this.weatherStationData = weatherStationResult.data;

			let streamGageResult = await Service.getStreamGagesByByArea(
				this.topLeftLat,
				this.topLeftLong,
				this.bottomRightLat,
				this.bottomRightLong
			);
			if (streamGageResult.ok === false) {
				throw streamGageResult.errorMessage;
			}
			this.streamGageData = streamGageResult.data;
			this.isLoaded = true;
		} catch (error) {
			this.isLoaded = false;
		} finally {
			//this.isLoading = false;
		}
	}

	/**
	 * Callback for when map is mounted.
	 */
	onMapMounted(map) {
		this.showLegendOnMap(map);
		map.mapObject.on("zoomend", this.showGridCellIds);
	}

	showLegendOnMap({ mapObject }) {
		var legend = L.control({ position: "bottomright" });
		legend.onAdd = function() {
			let div = L.DomUtil.create("div", "legend");
			let container =
				"<div style='height:130px; border: 1px solid #000; padding: 10px 25px; display:flex; border-radius:5%; background-color:#fff'>";
			let likelihood =
				"<div>" +
				"<h3>Flood Likelihood</h3>" +
				"<div style='height:15px;width:15px;background-color:#C4C3C0; margin:3px'><label style='padding-left:20px'>Unknown</label></div>" +
				"<div style='height:15px;width:15px;background-color:#47DE59; margin:3px'><label style='padding-left:20px'>Low</label> </div>" +
				"<div style='height:15px;width:15px;background-color:#EAC040; margin:3px'><label style='padding-left:20px'>Medium</label> </div>" +
				"<div style='height:15px;width:15px;background-color:#F47D68; margin:3px'><label style='padding-left:20px'>High</label> </div>" +
				"</div>";
			let stations =
				"<div style='padding-left: 15px;'>" +
				"<h3>Markers</h3>" +
				"<div style='text-align:left;'><img src='" +
				require(`@/map-icons/marker-icon-blue.png`) +
				"' style='height: 25px;'/><label style='padding-left:20px'>USGS Stream Gage</label></div>" +
				"<div style='text-align:left;'><img src='" +
				require(`@/map-icons/marker-icon-red.png`) +
				"' style='height: 25px;'/><label style='padding-left:20px'>Wx Station</label> </div>" +
				"</div>";

			div.innerHTML = container + likelihood + stations + "</div>";
			return div;
		};
		this.legendObj = legend;
		this.mapObject = mapObject;
		this.legendObj.addTo(this.mapObject);
	}
}
export default FloodDss;
</script>

<style lang="stylus" scoped>
.page
	width 100%
	max-width auto
	margin-top 4.5em
	padding-top 1px
	height 80vh
	display flex
	flex-direction row

::v-deep .grid-cell-id
	background #a9a9a9
	font-weight 700
	padding 2px
	color black
	text-align center
	border-radius 5px
</style>
